/* unplugin-vue-components disabled */import script from "./WhiteAddModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhiteAddModal.vue?vue&type=script&setup=true&lang=ts"

import "./WhiteAddModal.vue?vue&type=style&index=0&id=01842c6d&scoped=true&lang=less"
import "./WhiteAddModal.vue?vue&type=style&index=1&id=01842c6d&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01842c6d"]])

export default __exports__